import { render, staticRenderFns } from "./wechatLogin.vue?vue&type=template&id=abc3a362&scoped=true&"
import script from "./wechatLogin.vue?vue&type=script&lang=js&"
export * from "./wechatLogin.vue?vue&type=script&lang=js&"
import style0 from "./wechatLogin.vue?vue&type=style&index=0&id=abc3a362&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc3a362",
  null
  
)

export default component.exports